const reviews = [
  {
    name: 'Marcus J.',
    handle: '@marcusfindz',
    text: 'The Kakobuy spreadsheet completely changed how I shop. Instead of wasting hours scrolling through listings, I can compare everything in one organized place. Absolute game-changer for finding trending items quickly.',
  },
  {
    name: 'Elena R.',
    handle: '@elenashops',
    text: 'I was skeptical at first, but after using the Kakobuy sheet for a month, I am genuinely impressed. The categorization is thoughtful and the weekly updates keep everything fresh. My go-to resource now.',
  },
  {
    name: 'David K.',
    handle: '@davidkstyles',
    text: 'As someone who does product research professionally, the Kakobuy spreadsheet saves me at least 10 hours every week. The structure and level of detail in each category listing is unmatched.',
  },
  {
    name: 'Sophie L.',
    handle: '@sophiefinds',
    text: 'Finally, someone organized all the best finds into a clean spreadsheet format. I use the Kakobuy sheet every time I want to discover new trending products across different categories. Highly recommended.',
  },
  {
    name: 'Alex T.',
    handle: '@alextrends',
    text: 'The comparison tables within the Kakobuy spreadsheet are incredibly useful. Being able to see prices, ratings, and availability side by side makes decision-making so much faster and smarter.',
  },
  {
    name: 'Nina W.',
    handle: '@ninashopping',
    text: 'I have tried many shopping tools and spreadsheets over the years, but the Kakobuy sheet stands out for its quality and consistency. The community-driven verification adds an extra layer of trust.',
  },
];

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-6 md:px-10 max-w-[1440px] mx-auto">
        <div className="mb-12 md:mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-background-50 text-foreground-700 text-sm font-medium mb-4">
            Community Reviews
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            Trusted By Thousands
            <br />
            Of Smart Shoppers
          </h2>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6">
          {reviews.map((review) => (
            <div
              key={review.handle}
              className="break-inside-avoid mb-6 bg-background-50 rounded-2xl p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-600 font-semibold text-sm">{review.name.charAt(0)}</span>
                </div>
                <div>
                  <p className="font-semibold text-foreground-900 text-sm">{review.name}</p>
                  <p className="text-foreground-400 text-xs">{review.handle}</p>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed italic">
                &ldquo;{review.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}